export default [
  {
    path: '/main/reportcostmaterialtransportation',
    meta: {
      tag: 'report_cost_material_transportation',
      name: 'Custos com Transporte de Material',
      breadcrumb: 'Custos com Transporte de Material'
    },
    component: () => import(/* webpackChunkName: "report-cost-material-transportation" */ '@/views/main/reports/costmaterialtransportation/Index.vue'),
    children: [
      {
        path: '',
        name: 'listcostmaterialtransportation',
        meta: {
          tag: 'report_cost_material_transportation',
          name: 'Custos com Transporte de Material',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-cost-material-transportation" */ '@/views/main/reports/costmaterialtransportation/List.vue'),
      },
      {
        path: '/main/reportcostmaterialtransportation/add',
        name: 'addcostmaterialtransportation',
        meta: {
          tag: 'add_cost_material_transportation',
          menu: 'settings',
          name: 'Adicionar | Custo com Transporte de Material',
          breadcrumb: 'Adicionar Custo com Transporte de Material'
        },
        component: () => import(/* webpackChunkName: "report-cost-material-transportation" */ '@/views/main/reports/costmaterialtransportation/Add.vue')
      },
      {
        path: '/main/reportcostmaterialtransportation/:id',
        name: 'editcostmaterialtransportation',
        meta: {
          tag: 'edit_cost_material_transportation',
          menu: 'settings',
          name: 'Editar | Custo com Transporte de Material',
          breadcrumb: 'Editar Custo com Transporte de Material'
        },
        component: () => import(/* webpackChunkName: "report-cost-material-transportation" */ '@/views/main/reports/costmaterialtransportation/Edit.vue')
      }
    ]
  }
]
